var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',[_c('d-header',{attrs:{"fluid":"","breadcrumbs":false,"actions":[{
      label: _vm.$t('save'),
      primary: true,
      color: 'is-primary',
      action: _vm.submitForm
    }]}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.model.name)+"\n    ")])]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"edit","model":_vm.model}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }